'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { IconChevronUp } from '../../svg/icons/icon-chevron-up.js';

const FaqItem = ({ question, answer }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (jsxs("div", { className: "flex flex-col gap-4 border-leland-gray-stroke py-6 first:pt-0", children: [jsxs("button", { onClick: () => setIsOpen((prevState) => !prevState), className: "flex items-center justify-between", children: [jsx("h3", { className: "text-start text-lg font-medium text-leland-gray-dark", children: question }), jsx("div", { className: `transition-transform ${!isOpen ? 'rotate-180' : ''}`, children: jsx(IconChevronUp, { className: "size-6" }) })] }), isOpen ? (jsx("div", { className: "whitespace-pre-line text-left text-lg text-leland-gray-light", children: answer })) : null] }));
};
const Faq = ({ items, title }) => {
    return (jsxs("section", { className: "flex flex-col items-baseline justify-between gap-4 sm:flex-row", children: [title ? (jsx("h2", { className: "text-3xl font-medium text-leland-gray-dark", children: title })) : null, jsx("div", { className: `w-full divide-y ${title ? 'sm:w-3/5' : ''}`, children: items.map((item) => (jsx(FaqItem, { ...item }, item.question))) })] }));
};

export { Faq };
//# sourceMappingURL=faq.js.map
